const JAN_2020_PREFIX = `/privacy-jan-2020#privacy`;
const OCT_2020_PREFIX = `/privacy-oct-2020#privacy`;
const PRIVACY_PREFIX = `/privacy#privacy`;

export const PRIVACY_JAN_2020_LINKS_LIST = [
  {
    label: 'Personal information we collect',
    to: `${JAN_2020_PREFIX}-personal-information`,
  },
  {
    label: 'How we use personal information',
    to: `${JAN_2020_PREFIX}-how-we-use`,
  },
  {
    label: 'When we share your information',
    to: `${JAN_2020_PREFIX}-when-we-share-and-use`,
  },
  {
    label: 'Third Party Tools and Cookies',
    to: `${JAN_2020_PREFIX}-third-party-tools`,
  },
  {
    label: 'Third-Party Links',
    to: `${JAN_2020_PREFIX}-third-party-links`,
  },
  {
    label: 'Security',
    to: `${JAN_2020_PREFIX}-security`,
  },
  {
    label: 'Data Retention and Account Deactivation',
    to: `${JAN_2020_PREFIX}-data-retention`,
  },
  {
    label: 'Children',
    to: `${JAN_2020_PREFIX}-children`,
  },
  {
    label: 'Your California Privacy Rights',
    to: `${JAN_2020_PREFIX}-your-california`,
  },
  {
    label: 'Contact us',
    to: `${JAN_2020_PREFIX}-contact-us`,
  },
];

export const PRIVACY_OCT_2020_LINKS_LIST = [
  {
    label: 'Personal information we collect',
    to: `${OCT_2020_PREFIX}-personal-information`,
  },
  {
    label: 'How we use personal information',
    to: `${OCT_2020_PREFIX}-how-we-use`,
  },
  {
    label: 'When we share your information',
    to: `${OCT_2020_PREFIX}-when-we-share-and-use`,
  },
  {
    label: 'Third Party Tools and Cookies',
    to: `${OCT_2020_PREFIX}-third-party-tools`,
  },
  {
    label: 'Third-Party Links',
    to: `${OCT_2020_PREFIX}-third-party-links`,
  },
  {
    label: 'Security',
    to: `${OCT_2020_PREFIX}-security`,
  },
  {
    label: 'Data Retention and Account Deactivation',
    to: `${OCT_2020_PREFIX}-data-retention`,
  },
  {
    label: 'Children',
    to: `${OCT_2020_PREFIX}-children`,
  },
  {
    label: 'Your California Privacy Rights',
    to: `${OCT_2020_PREFIX}-your-california`,
  },
  {
    label: 'How To Make A Privacy Request',
    to: `${OCT_2020_PREFIX}-privacy-request`,
  },
  {
    label: 'Contact us',
    to: `${OCT_2020_PREFIX}-contact-us`,
  },
];

export const PRIVACY_2022_LINKS_LIST = [
  {
    label: 'Personal information we collect',
    to: `${PRIVACY_PREFIX}-personal-information`,
  },
  {
    label: 'How we use personal information',
    to: `${PRIVACY_PREFIX}-how-we-use`,
  },
  {
    label: 'Other information we may collect',
    to: `${PRIVACY_PREFIX}-other-information-collect`,
  },
  {
    label: 'When we share your information',
    to: `${PRIVACY_PREFIX}-when-we-share-and-use`,
  },
  {
    label: 'Third Party Tools and Cookies',
    to: `${PRIVACY_PREFIX}-third-party-tools`,
  },
  {
    label: 'Third-Party Links',
    to: `${PRIVACY_PREFIX}-third-party-links`,
  },
  {
    label: 'Security',
    to: `${PRIVACY_PREFIX}-security`,
  },
  {
    label: 'Data Retention and Account Deactivation',
    to: `${PRIVACY_PREFIX}-data-retention`,
  },
  {
    label: 'Children',
    to: `${PRIVACY_PREFIX}-children`,
  },
  {
    label: 'Your California Privacy Rights',
    to: `${PRIVACY_PREFIX}-your-california`,
  },
  {
    label:
      'For Data Subjects in the European Economic Area (“EEA”) and the United Kingdom (“UK”)',
    to: `${PRIVACY_PREFIX}-for-data-subjects`,
  },
  {
    label: 'How To Make A Privacy Request',
    to: `${PRIVACY_PREFIX}-privacy-request`,
  },
  {
    label: 'Contact us',
    to: `${PRIVACY_PREFIX}-contact-us`,
  },
];
